<template>
  <div class="language-switch">
    <Dropdown trigger="click" @on-click="switchLanguage" transfer>
      <a href="javascript:void(0)" :style="{ color: color }">
        {{ languageList[currentLanguage] }}
        <Icon type="ios-arrow-down"></Icon>
      </a>
      <template #list>
        <DropdownMenu>
          <DropdownItem v-for="(item, key) in languageList" :key="key" :name="key">{{ item }}</DropdownItem>
        </DropdownMenu>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { setLanguage } from '../../lang/i18n'

export default {
  props: {
    color: {
      type: String,
      default: '#2d8cf0'
    }
  },
  data () {
    return {
      languageList: {
        'zh-cn': '中文简体',
        'en-us': 'English',
        'ko-kr': '한국어'
      },
      currentLanguage: this.$i18n.locale
    }
  },
  methods: {
    switchLanguage (lang) {
      // 刷新页面以应用语言变化
      if (setLanguage(lang)) {
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped>
.language-switch {
  display: inline-block;
  margin-right: 10px;
}

.language-switch-text {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/common/LanguageSwitch.vue